import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';
import * as checkInReq from '../healthboard/requests/check-in-appointment-req';
import * as statusChangesReq from '../healthboard/requests/status-change-req';
import * as paymentVerification from '../healthboard/requests/payment-verifications-req';
import * as cancelOfficeVisitReq from '../healthboard/requests/cancel-appointment-req';
import { consts as SIGN_CONSENT_APPOINTMENT } from '../healthboard/requests/sign-appointment-consent-req';
import { consts as appointmentAccountFormPaymentConsts } from './requests/appointment-account-form-payment-req';
import { consts as SURVEY_COMPLETIONS } from '../surveys/upcoming-survey-completions';
import { findAndReplace } from '../../utils/arrayModify';

export const consts = createReqConsts('appointmnents', 'details');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'appointments',
    {
      type: 'payload',
      selector: ['appointmentId'],
    },
  ],
});

const defaultRequestReducer = createReqReducer(consts, true);

export default (state, action) => {
  switch (action.type) {
    case checkInReq.consts.SUCCEED: {
      return {
        ...state,
        data: {
          ...state.data,
          status: action.payload.status,
          allowedActions: action.payload.allowedActions,
        },
      };
    }

    case paymentVerification.consts.SUCCEED:
    case appointmentAccountFormPaymentConsts.SUCCEED: {
      return {
        ...state,
        data: action.payload.payable,
      };
    }

    case statusChangesReq.consts.SUCCEED: {
      return {
        ...state,
        data: {
          ...state.data,
          status: action.payload.status,
          allowedActions: action.payload.allowedActions,
        },
      };
    }

    case SIGN_CONSENT_APPOINTMENT.SUCCEED: {
      if (state.data && state.data.consentsAssignment) {
        const allConsents = state.data.consentsAssignment.consents || [];
        const targetConsent =
          allConsents.length > 0
            ? allConsents.filter(
                consent => consent.id === action.payload.appointmentConsentId,
              )
            : [];
        if (targetConsent && targetConsent[0]) {
          targetConsent[0].accepted = true;
        }
        return {
          ...state,
          data: {
            ...state.data,
            consentsAssignment: {
              ...state.data.consentsAssignment,
              consents: findAndReplace(allConsents, {
                ...targetConsent[0],
              }),
            },
          },
        };
      }
      return {
        ...state,
      };
    }

    case cancelOfficeVisitReq.consts.SUCCEED: {
      return {
        ...state,
        data: {
          ...state.data,
          status: action.payload.status,
          allowedActions: action.payload.allowedActions,
        },
      };
    }

    case SURVEY_COMPLETIONS.SUCCEED: {
      if (state.data) {
        const userAppointmentId = action.payload.userAppointment
          ? action.payload.userAppointment.id
          : null;
        const targetAppointment = userAppointmentId === state.data.id;

        if (!targetAppointment) return state;

        const handleReplaceItem = (allItem, item) => {
          if (item) {
            const index = allItem.findIndex(({ assignmentId }) => {
              return item.assignmentId === assignmentId;
            });
            allItem.splice(index, 1, item);
            return allItem;
          }
        };

        return {
          ...state,
          data: {
            ...state.data,
            surveyAssignments: handleReplaceItem(
              state.data.surveyAssignments,
              action.payload,
            ),
          },
        };
      }

      return state;
    }

    default:
      return defaultRequestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/appointmnents/appointment-details-req.js